var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3",staticStyle:{"background-color":"rgb(244, 245, 247)"}},[(_vm.user.level == 'Admin')?_c('div',[_c('AdminInterface')],1):_c('div',[_c('UserInterface')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }